import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

const H5 = ({ tag: Tag = "h5", children, className, ...rest }) => (
  <Tag
    className={classNames(
      "m-0",
      "text-xl",
      "font-semibold",
      "line-height-100",
      "text-black",
      className
    )}
    {...rest}
  >
    {children}
  </Tag>
);

H5.propTypes = {
  tag: PropTypes.elementType,
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

export default H5;
